export enum TextEditorHeight {
  Small = 28,
  Medium = 40,
}
